<template>
  <div class="btn-language">
    <p>
      {{ lang.key }}
      <i class="icon-lang"/>
    </p>
    <select v-model="changeLang">
      <option
        v-for="(item) in setLang"
        :value="item.key"
        :key="item.key">
        {{ item.lang }}
      </option>
    </select>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'BtnLanguage',
  components: {
    mapGetters
  },
  data () {
    return {
      setLang: [
        {key: 'JP', lang: '日本語（JP）', params: 'ja'},
        {key: 'EN', lang: 'English（EN）', params: 'en'},
        {key: 'CN', lang: '简体中文（CN）', params: 'zh-CN'},
        {key: 'TW', lang: '繁體中文（TW）', params: 'zh-TW'},
        {key: 'KO', lang: '한국어（KO）', params: 'ko'},
        {key: 'RU', lang: 'Русский（RU）', params: 'ru'},
        {key: 'FR', lang: 'Français（FR）', params: 'fr'},
        {key: 'DE', lang: 'Deutsch（DE）', params: 'de'},
        {key: 'ES', lang: 'Español（ES）', params: 'es'},
        {key: 'PT', lang: 'Português（PT）', params: 'pt'},
        {key: 'IT', lang: 'Italiano（IT）', params: 'it'},
        {key: 'TH', lang: 'ไทย（TH）', params: 'th'}
      ],
      changeLang: ''
    }
  },
  computed: {
    ...mapGetters(['textData', 'lang'])
  },
  methods: {
  },
  mounted () {
    this.changeLang = this.lang.key
  },
  created () {
  },
  watch: {
    'changeLang': function () {
      console.log('watch2', this.changeLang, typeof this.changeLang)
      let changeData = this.setLang.find((lang) => {
        return (lang.key === this.changeLang)
      })
      this.$store.dispatch('setLang', {
        name: changeData
      })
      this.$store.dispatch('setMuseumList').then(res => {
        console.log(res)
      }, err => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="postcss" scoped>
  @import '../../assets/css/mixins.css';
  @import '../../assets/css/variables.css';

  .btn-language {
    width: 110px;
    height: 50px;
    & p {
      position: absolute;
      top: 0;
      /* right: 35px; */
      width: 110px;
      height: 50px;
      font-size: 15px;
      line-height: 50px;
      text-align: center;
      /* margin: 15px 0; */
      & .icon-lang {
        display: inline-block;
        width: 24px;
        height: 24px;
        vertical-align: top;
        margin: 13px 15px 0 5px;
        background: url('~@/assets/img/icon-language.png');
        background-size: 24px;
      }
    }
    & select {
      opacity: 0;
      position: absolute;
      top: 0;
      right: 0;
      width: 110px;
      height: 100%;
      color: #000000;
      cursor: pointer;
    }
  }
  @media (--breakPoint) {
    .btn-language {
      position: relative;
      width: 110px;
      height: 35px;
      margin: auto;
      & p {
        position: absolute;
        right: 0;
        width: 110px;
        height: 35px;
        line-height: 35px;
        text-align: center;
        margin: 0;
        & .icon-lang {
          margin: 5px 15px 0 5px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/atoms/BtnLanguage.vue